<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="abandonForm">
		<div class="grid">
			<div class="col-12">
				<div class="flex align-items-center justify-content-center gap-3">
					<div class="pi cm-alert text-4xl"></div>
					{{ 'ABANDON_DEVICE_PLANTS_WARNING' | translate }}
				</div>
			</div>
			<div class="col-12">
				<div class="flex align-items-center justify-content-center">
					<p-checkbox formControlName="abandonForm" name="cleanup" [binary]="true" styleClass="mx-2"></p-checkbox>
					<div class="text-50">{{ 'VCT_SHARE_CLEANUP' | translate }}</div>
				</div>
			</div>
		</div>

		<!-- Confirm Dialog Buttons Style -->
		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple
				label="{{ 'CONFIRM' | translate }}"
				class="p-button-danger font-normal mt-2 mx-1"
				>
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()"
				label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary font-normal mt-2 mx-1"
				>
			</button>
		</div>
	</form>
</div>
